export const STATUS_CODES = {
  CODE200: 200,
  CODE404: 404,
  CODE301: 301,
  CODE302: 302,
  CODE500: 500,
}

export const DOMAINS = {
  CHILD_CARE_ADVANTAGE: 'childcareadvantage.com',
  CANADIAN_NANNY: 'canadiannanny.ca',
  HOUSE_KEEPER: 'housekeeper.com',
  HOUSE_SITTER: 'housesitter.com',
  SITTER: 'sitter.com',
  PET_SITTER: 'petsitter.com',
  ELDER_CARE: 'eldercare.com',
  MOM_TERESA: 'momteresa.com',
  MEET_A_CARPENTER: 'meetacarpenter.com',
  MEET_A_GARDENER: 'meetagardener.com',
  MEET_A_LANDSCAPER: 'meetalandscaper.com',
  MEET_AN_ACCOUNTANT: 'meetanaccountant.com',
  MEET_AN_ENGINNER: 'meetanengineer.com',
  MEET_A_CHEF: 'meetachef.com',
  MEET_A_HANDYMAN: 'meetahandyman.com',
  MEET_A_MECHANIC: 'meetamechanic.com',
  MEET_AN_ELECTRICIAN: 'meetanelectrician.com',
  MEET_A_PAINTER: 'meetapainter.com',
  MEET_A_PHOTOGRAPHER: 'meetaphotographer.com',
  MEET_A_PROGRAMMER: 'meetaprogrammer.com',
  MEET_A_ROOFER: 'meetaroofer.com',
  MEET_A_SECURITY_GUARD: 'meetasecurityguard.com',
  MEET_A_TUTOR: 'meetatutor.com',
  MEET_A_WEB_DEVELOPER: 'meetawebdeveloper.com',
  MEET_A_PLUMBER: 'meetaplumber.com',
  MEET_A_RENOVATOR: 'meetarenovator.com',
  MEET_A_SALESMAN: 'meetasalesman.com',
  MEET_A_TRUCK_DRIVER: 'meetatruckdriver.com',
  MEET_A_VIDEOGRAPHER: 'meetavideographer.com',
  MEET_A_WRITER: 'meetawriter.com',
}

export const MEETAS = [
  DOMAINS.MEET_A_CARPENTER,
  DOMAINS.MEET_A_GARDENER,
  DOMAINS.MEET_A_LANDSCAPER,
  DOMAINS.MEET_AN_ACCOUNTANT,
  DOMAINS.MEET_AN_ENGINNER,
  DOMAINS.MEET_A_CHEF,
  DOMAINS.MEET_A_HANDYMAN,
  DOMAINS.MEET_A_MECHANIC,
  DOMAINS.MEET_AN_ELECTRICIAN,
  DOMAINS.MEET_A_PAINTER,
  DOMAINS.MEET_A_PHOTOGRAPHER,
  DOMAINS.MEET_A_PROGRAMMER,
  DOMAINS.MEET_A_ROOFER,
  DOMAINS.MEET_A_SECURITY_GUARD,
  DOMAINS.MEET_A_TUTOR,
  DOMAINS.MEET_A_WEB_DEVELOPER,
  DOMAINS.MEET_A_PLUMBER,
  DOMAINS.MEET_A_RENOVATOR,
  DOMAINS.MEET_A_SALESMAN,
  DOMAINS.MEET_A_TRUCK_DRIVER,
  DOMAINS.MEET_A_VIDEOGRAPHER,
  DOMAINS.MEET_A_WRITER,
]

export const REGEX_PATTERNS = {
  PHONE_NUMBER: new RegExp(
    '^(?:(?:\\+?1\\s*(?:[.-]\\s*)?)?(?:\\(\\s*([2-9]1[02-9]|[2-9]' +
      '[02-8]1|[2-9][02-8][02-9])\\s*\\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\\s*(?:[.-]' +
      '\\s*)?)([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\\s*(?:[.-]\\s*)?([0-9]{4})$'
  ),
}

export const FONT_FAMILY = {
  PROXIMA_NOVA: "'Proxima Nova', 'Helvetica Neue', Helvetica, Arial, sans-serif",
}

export const LISTING_TYPE = {
  JOBS: 'jobs',
  PROFILES: 'profiles',
}
